import { Button as ChakraButton, ButtonProps } from '@chakra-ui/button'

import { darken } from 'polished'

export function Button({ type, isLoading, children, ...props }: ButtonProps) {
  return (
    <ChakraButton
      type={type}
      size="lg"
      fontSize="sm"
      fontWeight="normal"
      background="parkoff.orange.300"
      borderRadius="md"
      textColor="parkoff.gray.800"
      isLoading={isLoading}
      _hover={{
        background: darken(0.1, '#FFBE3E'),
      }}
      {...props}
    >
      {children}
    </ChakraButton>
  )
}
